export default __webpack_public_path__ + "static/media/Myths.b8514161.svg";